// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "/* Styling the scrollbar in Chrome and Safari */\n::-webkit-scrollbar {\n  width: 6px;\n  height: 6px;\n}\n\n::-webkit-scrollbar-thumb {\n  background-color: #8d8d8d;\n  /* Set thumb color for Chrome and Safari */\n  border-radius: 10px;\n}\n\n::-webkit-scrollbar-track {\n  background-color: transparent;\n  /* Set track color for Chrome and Safari */\n}\n", ""]);
// Exports
module.exports = exports;
